<template>
  <div class="box box--story">
    <div class="box-img-wrapper">
      <VideoWrapper v-if="box.videoURL" :videoLink="box.videoURL" :withoutPlayButton="true"></VideoWrapper>
      <ImageWrapper v-else :file="box.idFile" :key="box.idFile"></ImageWrapper>
    </div>
    <div class="box-inner">
      <router-link :to="{name: 'SolutionProcess', params: {id: box.idSolution}}" class="box-title"><span>{{box.headline}}</span></router-link>
      <p v-if="box.lead">{{box.lead}}</p>
      <div class="box-bottom2"><a>Read more</a></div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import VideoWrapper from "@/components/general/VideoWrapper";
export default {
  name: "BoxStory",
  components: {VideoWrapper, ImageWrapper},
  props: ['box'],
}
</script>
